import { trackEvent, trackEcommerce } from 'dibs-tracking';

// types
import { ItemType as RecentHistoryItemType } from './recentHistoryTypes';

const LIST_NAME = 'recently viewed items carousel';

const trackInteraction = ({ action, label }: { action: string; label: string }): void => {
    trackEvent({
        category: 'promo interaction',
        action,
        label,
        value: 0,
    });
};

const trackViewMoreCtaClick = ({ label }: { label: string }): void => {
    trackInteraction({
        action: 'recently viewed view more clicked',
        label,
    });
};

export const trackHpViewMoreCtaClick = (): void => trackViewMoreCtaClick({ label: '[homepage]' });
export const trackPdpViewMoreCtaClick = (): void => trackViewMoreCtaClick({ label: '[pdp]' });
export const trackSbViewMoreCtaClick = (): void => trackViewMoreCtaClick({ label: '[s&b]' });

export const trackInitialDisplay = ({ itemsReturned }: { itemsReturned: string }): void => {
    trackInteraction({
        action: 'recently viewed items displayed',
        label: itemsReturned,
    });
};

export const trackArrowClick = ({ direction }: { direction: string }): void => {
    trackInteraction({
        action: 'recently viewed items arrow clicked',
        label: direction,
    });
};

export const trackItemClick = (): void => {
    trackInteraction({
        action: 'recently viewed items item clicked',
        label: 'none',
    });
};

type RecentItemsProp = {
    type: string;
    items: RecentHistoryItemType[];
    startIndex: number;
    variant: string;
};

export const trackRecentItems = ({ type, items, startIndex, variant }: RecentItemsProp): void => {
    trackEcommerce({
        type,
        actionField: { list: LIST_NAME },
        products: items.map((item, index) => ({
            brand: item.dealerPk,
            category: item.itemBrowseUrl || item.category,
            categoryCode: item.itemCategoryCode,
            id: item.itemId,
            variant,
            name: item.itemTitle,
            list: LIST_NAME,
            dimension83: item.contemporaryTrackingString,
            position: startIndex + index,
        })),
    });
};
